import { z } from 'zod';
import { COMPULSORY_INSURANCE_PENALTY_STATE_VALUE } from './compulsoryInsurancePenaltyTicketState';

export enum VehicleType {
  CAR = 'CAR',
  MOTO = 'MOTO',
  HEAVY_MOTO = 'HEAVY_MOTO',
  TRAILER = 'TRAILER',
  MICRO_ELECTRIC_BIKE = 'MICRO_ELECTRIC_BIKE',
}

export const VehicleTypeValues = [
  VehicleType.CAR,
  VehicleType.MOTO,
  VehicleType.HEAVY_MOTO,
  VehicleType.TRAILER,
  VehicleType.MICRO_ELECTRIC_BIKE,
];

export const VEHICLE_TYPE_LABEL: Record<VehicleType, string> = {
  [VehicleType.CAR]: '汽車',
  [VehicleType.MOTO]: '機車',
  [VehicleType.HEAVY_MOTO]: '重型機車',
  [VehicleType.TRAILER]: '拖車',
  [VehicleType.MICRO_ELECTRIC_BIKE]: '微型電動二輪車',
};

export const VehicleTypeSchema = z.enum(VehicleTypeValues);

const CompulsoryInsurancePenaltyTicketAccountSchema = z.object({
  id: z.string(),
  email: z.string(),
});

const CompulsoryInsurancePenaltyTicketOperatorNoteSchema = z.object({
  id: z.string(),
  operator: z.string(),
  content: z.string(),
  createDateTime: z.string(),
});

const CompulsoryInsurancePenaltyTicketSchema = z.object({
  id: z.string(),
  compulsoryInsurancePenaltyAutoPayEnrollmentId: z.string(),
  account: CompulsoryInsurancePenaltyTicketAccountSchema,
  plateNumber: z.string(),
  vehicleType: z.nativeEnum(VehicleType).nullable().default(null),
  state: z.enum(COMPULSORY_INSURANCE_PENALTY_STATE_VALUE),
  amount: z.number().nullable().default(null),
  handlingFee: z.number().nullable().default(null),
  paymentId: z.string().nullable().default(null),
  completeDateTime: z.string().nullable().default(null),
  createDateTime: z.string(),
  updateDateTime: z.string(),
  reason: z.string().nullable().default(null),
  operatorNotes: z
    .array(CompulsoryInsurancePenaltyTicketOperatorNoteSchema)
    .default([]),
});

const CompulsoryInsurancePenaltyTicketSummarySchema =
  CompulsoryInsurancePenaltyTicketSchema.omit({ operatorNotes: true });

type CompulsoryInsurancePenaltyTicketAccount = z.infer<
  typeof CompulsoryInsurancePenaltyTicketAccountSchema
>;
type CompulsoryInsurancePenaltyTicketOperatorNote = z.infer<
  typeof CompulsoryInsurancePenaltyTicketOperatorNoteSchema
>;
type CompulsoryInsurancePenaltyTicket = z.infer<
  typeof CompulsoryInsurancePenaltyTicketSchema
>;
type CompulsoryInsurancePenaltyTicketSummary = z.infer<
  typeof CompulsoryInsurancePenaltyTicketSummarySchema
>;

export {
  CompulsoryInsurancePenaltyTicketAccountSchema,
  CompulsoryInsurancePenaltyTicketOperatorNoteSchema,
  CompulsoryInsurancePenaltyTicketSchema,
  CompulsoryInsurancePenaltyTicketSummarySchema,
};

export type {
  CompulsoryInsurancePenaltyTicketAccount,
  CompulsoryInsurancePenaltyTicketOperatorNote,
  CompulsoryInsurancePenaltyTicket,
  CompulsoryInsurancePenaltyTicketSummary,
};
